import type { FetchAllLinkCollectionsResponseAction } from './fetchAllLinkCollections.action';
import type { FetchOriginalWebUrlLinkDataResponseAction } from './fetchOriginalWebUrlLinkData.action';
import type { UpdateOriginalWebUrlLinkDataStatusResponseAction } from './updateOriginalWebUrlLinkDataStatus.action';

export * from './fetchOriginalWebUrlLinkData.action';
export * from './updateOriginalWebUrlLinkDataStatus.action';
export * from './fetchAllLinkCollections.action';

export type LinkHubCreatorAction =
  | FetchOriginalWebUrlLinkDataResponseAction
  | UpdateOriginalWebUrlLinkDataStatusResponseAction
  | FetchAllLinkCollectionsResponseAction;
